<template>
  <div class="fazhan">
    <div class="header animate__animated wow animate__fadeInUp">
      <div class="IosPic">
        <img src="../../assets/image/About/fazhan1.png" alt="" />
      </div>
      <div class="left">
        GYT is committed to providing innovative services and quality products
        for kidney disease patients. We continue to provide one-stop solutions
        for patients, hospital departments, doctors and nurses, and enterprises.
        The business consists of five parts — "Innovation Services", "Industrial
        Production", "Business Network", "Medical Training" and "Information
        Platform".
      </div>
      <div class="right">
        <img src="../../assets/image/About/fazhan1.png" alt="" />
      </div>
    </div>
    <div class="title">
      <titleCard title="The GYT Timeline"></titleCard>
    </div>
    <div class="main animate__animated wow animate__fadeInUp">
      <div class="main-box">
        <div class="box box1">
          <div class="dian"></div>
          <div class="text text1">
            <div class="content">
              <p>Contracted a community dialysis service agreement with Nagoya Hospital；</p>
              <p>Has a service cooperation agreement with haqi hospital</p>
              </div>
            <div class="titles">
              The 2016 GYT
            </div>
          </div>
        </div>
        <div class="box box2">
          <div class="dian"></div>
          <div class="text text2">
            <div class="titles">
              In 2017
            </div>
            <p>Dcheng capital injection of 22 million RMB, obtaining the national ‘high technology enterprises ’certificate;</p>
            <p>A cooperative service agreement was signed with Jilin Zhengda international hospital.</p>
          </div>
        </div>
        <div class="box box3">
          <div class="dian"></div>
          <div class="text text3">
            <p>Together with Peking University People's Hospital, the ‘Specialized Committee for blood purification of the Chinese Research Hospital Society ’was established, with members covering 102 well-known experts in Nephrology;</p>
            <p>The disingence capital injects 60 million RMB and the postinvestment estimate is 240 million RMB.</p>
            <div class="titles">
             In 2018
            </div>
          </div>
        </div>
        <div class="box box4">
          <div class="dian"></div>
          <div class="text text4">
            <div class="titles">
              In 2019
            </div>
            <p>Was authorized by the National Health Commission stepeducation center ‘national hemodialysis specific capacity training ’ program;</p>
            <p>Contract with PKU international hospital to create the first dialysis refresh base of the health commission.</p>
          </div>
        </div>
        <div class="box box5">
          <div class="dian"></div>
          <div class="text text5">
            <p>Obtained from the hemodialysis collaborative pilot unit of the National Health Commission‘capacity improvement engineering of medical and health services at the county level ’;</p>
            <p>Complete the layout of the first autonomous industrial product.</p> 
            <div class="titles">
              In 2020
            </div>
          </div>
        </div>
        <div class="box box6">
          <div class="dian"></div>
          <div class="text text6">
            <div class="titles">
              In 2021
            </div>
            The business network, training network, industrial network was further improved, and the new round of financing was completed.
          </div>
        </div>
        <div class="box box7">
          <div class="dian"></div>
          <div class="text text7">
            As of July the business has covered 500 + facilities, of which 150 + are primary care facilities.
            <div class="titles">
             In 2022
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer animate__animated wow animate__fadeInUp">
      <div class="footer-title">
        <titleCard title="Contact Us"></titleCard>
      </div>
      <div class="map">
        <template>
          <iframe src="http://testwww.gytcare.com/map.html" width="100%" height="100%" frameborder="0"></iframe>
        </template>
      </div>
      <div class="address">
        <div class="txtbox">
          <h3>Address：</h3>
          <p>Room 704, block B, Jiatai building, No. 41, East Fourth Ring Middle Road, Chaoyang District, Beijing</p>
        </div>
        <div class="txtbox right">
          <h3>&nbsp;</h3>
          <p>Room 713, block B, Jiatai building, No. 41, East Fourth Ring Middle Road, Chaoyang District, Beijing</p>
        </div>
        <div class="icon">
          <img src="../../assets/image/About/icon1.webp" alt="" />
        </div>
      </div>
      <div class="phone">
        <div class="txtbox">
          <h3>Contact number：</h3>
          <p>010-67207401</p>
        </div>
        <div class="txtbox txtbox1">
          <h3>Contact email：</h3>
          <p>zhangshixia@gytcare.com</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titleCard from "../../components/title-card.vue";
export default {
  data() {
    return {};
  },
  components: {
    titleCard,
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.fazhan {
  position: relative;
  .header {
    height: 7.6842rem;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 540px) {
      height: 100%;
      display: block;
    }
    .IosPic {
      display: none;
      width: 100%;
      height: 260px;
      @media screen and (max-width: 540px) {
        display: block;
      }
      margin: 25px 0;
      padding: 0 55px;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .left {
      width: 5.5789rem;
      font-size: 18px;
      line-height: 0.35rem;
      @media screen and (max-width: 540px) {
        width: 100%;
      line-height: 30px;
        padding: 0 25px;
        box-sizing: border-box;
      }
      p {
        padding-bottom: 0.3789rem;
        color: #666666;
        font-size: 0.2105rem;
        @media screen and (max-width: 540px) {
          font-size: 15px;
          padding-bottom: 20px;
        }
      }
    }
    .right {
      @media screen and (max-width: 540px) {
        display: none;
      }
      margin-left: 1.4105rem;
      width: 6.5421rem;
      height: 5.6632rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .main::-webkit-scrollbar {
    display: none;
  }
  .title {
    position: absolute;
    left: 50%;
    top: 30%;
    z-index: 999;
    transform: translateX(-50%);
    @media screen and (max-width: 540px) {
      top: 34%;
    }
  }
  .main {
     height: 10.9474rem;
    width: 100%;
    background-image: url('../../assets/image/About/xian.png');
    background-size: 100% 100%;
    box-sizing: border-box;
    position: relative;
    @media screen and (max-width: 540px) {
      background-image: none;
      height: 800px;
      overflow: scroll;
      overflow-y: hidden;
      background: none;
      padding: 0;
    }
    .box {
      position: absolute;
      @media screen and (max-width: 540px) {
        display: none;
      }
      .text {
        position: absolute;
        height: auto;
        top: 0;
        left: 0;
        font-size: 0.1595rem;
        padding-left: 0.3rem;
        color: #666666;
        .titles {
          font-size: 0.2632rem;
          color: #0ca6eb;
          margin: 0.2105rem 0;
          display: flex;
          align-items: center;
          font-weight: 600;
          .icon {
            width: 0.2105rem;
            height: 0.2105rem;
            margin-right: 0.1474rem;
            background: url('../../assets/image/About/bottom.png') no-repeat;
            background-size: 100% 100%;
          }
          .icon2 {
            background: url('../../assets/image/About/top.png') no-repeat;
            background-size: 100% 100%;
          }
        }
      }
      .text1 {
        width: 3.9474rem;
        left: -0.1063rem;
        top: -1.7542rem;
        p{
          padding-bottom: 10px;
        }
      }
      .text2 {
        width: 5.1474rem;
        left: -0.1063rem;
        top: 0.08rem;
        p{
          padding-top: 10px;
        }
      }
      .text3 {
        width: 5rem;
        top: -2.27rem;
        left: -0.1rem;
        p{
          padding-bottom: 15px;
        }
      }
      .text4 {
        width: 4.8474rem;
        left: -0.1063rem;
        top: 0.05rem;
        p{
          padding-top: 10px;
        }
      }
      .text5 {
        width: 4.5rem;
        top:-2.1547rem;
        left: -0.05rem;
        p{
          padding-bottom: 15px;
        }
      }
      .text6{
        width: 3.8474rem;
        left: -0.1063rem;
        top: 0.08rem;
      }
      .text7 {
        width: 3.3rem;
        top: -2.1421rem;
        left: -0.1053rem;
      }
      .dian {
        width: 0.2632rem;
        height: 0.2632rem;
        // background: url('../../assets/image/About/xian.png') no-repeat;
        background-size: 100% 100%;
        margin-left: -0.1263rem;
        margin-bottom: -0.0526rem;
      }
    }
    .box1 {
      left: 0.7089rem;
      bottom: 1.6032rem;
    }
    .box2 {
      left: 4.5911rem;
      bottom: 2.6211rem;
    }
    .box3 {
      left: 6.05979rem;
      bottom: 3.8842rem;
    }
    .box4 {
      left: 9.09953rem;
      bottom: 4.2632rem;
    }
    .box5 {
      right: 8.4084rem;
      bottom: 4.85rem;
    }
    .box6 {
      right: 5.9532rem;
      bottom: 5.0874rem;
    }
    .box7 {
      right: 3.7474rem;
      bottom: 5.7368rem;
    }
    .main-box {
      width: 100%;
      height: 100%;
      background-size: 100% 100%;
      @media screen and (max-width: 540px) {
        background-size: 100% 100%;
        height: 100%;
        width:1400px;
        background: url('../../assets/image/About/licheng-ios.png');
        background-size: 100% 100%;
        background-position: 0 100%;
      }
    }
  }
  .footer {
    padding: 0.8632rem 1.6842rem 1.6842rem 1.6842rem;
    @media screen and (max-width: 540px) {
      padding: 0 15px;
    }
    .footer-title {
      margin-bottom: 0.5684rem;
      @media screen and (max-width: 540px) {
        padding: 58px 0 20px 0;
      }
    }
    .map {
      height: 3.3589rem;
      width: 100%;
      background: url("../../assets/image/About/map.webp") no-repeat;
      background-size: 100% 100%;
      @media screen and (max-width: 540px) {
        height: 170px;
        background-size: cover;
        background-position-x: 50%;
      }
    }
    .address {
      padding: 0 0.3158rem;
      padding-top: 0.5rem;
      border-bottom: 1px solid #e1e1e1;
      display: flex;
      align-items: center;
      @media screen and (max-width: 540px) {
        height: 100%;
        padding: 19px 0;
      }
      .txtbox {
        flex: 1;
        // width: 5.4737rem;
        @media screen and (max-width: 540px) {
          width: 50%;
          padding: 0;
        }
        h3 {
          color: #6a7073;
          font-size: 0.2526rem;
          margin: 0;
          @media screen and (max-width: 540px) {
            font-size: 14px;
          }
        }
        p {
          padding: 0.2421rem 0;
          font-size: 0.2526rem;
          color: #888a8b;
          @media screen and (max-width: 540px) {
            padding-right: 10px;
            font-size: 12px;
          }
        }
      }
      .right {
        @media screen and (max-width: 540px) {
          padding: 0;
        }
      }
      .icon {
        width: 0.3684rem;
        height: 0.4842rem;
        margin-top: 0.4211rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .phone {
      height: 1.6316rem;
      display: flex;
      align-items: center;
      padding: 0 0.3158rem;
      @media screen and (max-width: 540px) {
        height: 100%;
        padding: 19px 0;
      }
      .txtbox1{
        margin-left: -0.3rem;
      }
      .txtbox {
        // width: 5.4737rem;
        flex: 1;
        @media screen and (max-width: 540px) {
          width: 50%;
          padding: 0;
        }
        h3 {
          color: #6a7073;
          font-size: 0.2526rem;
          margin: 0;
          @media screen and (max-width: 540px) {
            font-size: 14px;
          }
        }
        p {
          padding-top: 0.2421rem;
          font-size: 0.2526rem;
          color: #888a8b;
          @media screen and (max-width: 540px) {
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
